import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function ArticleGrid() {
  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-100/50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <p className="text-xs font-semibold text-primary-500 uppercase tracking-widest mb-3">
            Artigos SEO
          </p>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
            Guias e Artigos
            <br />
            <span className="text-foreground-500">sobre Hoobuy Spreadsheet</span>
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto mt-4 leading-relaxed">
            Conteúdo original e atualizado para ajudar você a dominar o Hoobuy
            Spreadsheet e fazer as melhores compras da China.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/artigo/${article.slug}`}
              className="group bg-background-50 border border-background-200/60 rounded-xl overflow-hidden hover:border-primary-200/60 transition-all cursor-pointer flex flex-col"
            >
              <div className="relative h-44 md:h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  <span className="px-2.5 py-1 text-[10px] font-semibold text-background-50 bg-foreground-900/60 backdrop-blur-sm rounded-full whitespace-nowrap">
                    {article.readTime}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <p className="text-[11px] text-foreground-400 mb-2">{article.date}</p>
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-2 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 flex-1">
                  {article.metaDescription}
                </p>
                <span className="inline-flex items-center gap-1 mt-3 text-xs font-medium text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                  Ler artigo completo
                  <i className="ri-arrow-right-line text-xs group-hover:translate-x-0.5 transition-transform"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-2.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-all cursor-pointer whitespace-nowrap"
          >
            Acessar Hoobuy Sheet
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}